import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';

const rochePipelineCaptionCss = ".diagnostics-caption{max-width:18.75rem;margin-top:3rem}@media (min-width: 20rem){.diagnostics-caption{margin-top:2rem}}@media (min-width: 48rem){.diagnostics-caption{margin-top:3rem}}.diagnostics-caption__item-abbreviation{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--caption--font-size--small-up);line-height:1.1875rem;font-weight:400}@media (min-width: 48rem){.diagnostics-caption__item-abbreviation{font-size:var(--caption--font-size--medium-up);line-height:1.375rem}}.diagnostics-caption__item-description{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--caption--font-size--small-up);line-height:1.1875rem}@media (min-width: 48rem){.diagnostics-caption__item-description{font-size:var(--caption--font-size--medium-up);line-height:1.375rem}}:host([dir=rtl]) .diagnostics-caption-__item-abbreviation{display:inline-flex;align-items:baseline}";
const RochePipelineCaptionStyle0 = rochePipelineCaptionCss;

const RochePipelineCaption = /*@__PURE__*/ proxyCustomElement(class RochePipelineCaption extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.captionList = undefined;
        this.captionString = undefined;
    }
    captionStringChangeHandler(newValue) {
        this.captionList = newValue ? JSON.parse(newValue) : this.captionList;
    }
    componentWillLoad() {
        this.captionStringChangeHandler(this.captionString);
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        var _a;
        return (h("div", { key: 'bbf7d7bd8e82c370eb732d902a87164e85909bdc', class: "diagnostics-caption" }, (_a = this.captionList) === null || _a === void 0 ? void 0 : _a.map((item, index) => (h("div", { key: `diagnostics-caption-${index}`, class: "diagnostics-caption__item" }, h("span", { class: "diagnostics-caption__item-abbreviation" }, h("sup", null, item.sup), item.abbreviation), h("span", { class: "diagnostics-caption__item-description" }, item.description))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "captionString": ["captionStringChangeHandler"]
    }; }
    static get style() { return RochePipelineCaptionStyle0; }
}, [1, "roche-pipeline-caption", {
        "captionList": [1040],
        "captionString": [1, "caption-string"]
    }, undefined, {
        "captionString": ["captionStringChangeHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-pipeline-caption"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-pipeline-caption":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RochePipelineCaption);
            }
            break;
    } });
}

export { RochePipelineCaption as R, defineCustomElement as d };

//# sourceMappingURL=roche-pipeline-caption2.js.map